import React from 'react';
import { Select } from 'antd';

export default ({onChange, value, id}) => {
    const [cates, setCates] = React.useState([]);
    const [currentCateIds, setCurrentCateIds] = React.useState([value]);

    React.useEffect(() => {
        getCates().then(res => {
            setCates(res);
        })
    }, []);

    React.useEffect(() => {
        console.log(value);
        setCurrentCateIds([value]);
    }, [value]);

    const onCateChange = (value, selectedOptions) => {
        console.log(value, selectedOptions);
        setCurrentCateIds([value]);

        onChange?.(value);
    };

    const getCates = async () => {
        let response = await fetch('/api/sys-category/list');
        let result = await response.json();

        if(result && result.success) { 
            return result.data;
        }
        return [];
    }

    return (
        <Select
            id={id}
            options={cates}
            // defaultValue={currentCateIds}
            value={currentCateIds}
            // expandTrigger="hover"
            // displayRender={displayRender}
            onChange={onCateChange}
        />
    )
}